//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getproductinfo as _getproductinfo } from "@/api/user";
export default {
  name: 'about',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      data: {}
    };
  },
  watch: {
    dialogVisible: {
      handler: function handler(newVal, oldVal) {
        if (newVal) {
          this.getproductinfo();
        }
      },
      immediate: true
    }
  },
  methods: {
    close: function close() {
      this.$emit('closeDialog', false);
    },
    getproductinfo: function getproductinfo() {
      var _this = this;

      _getproductinfo().then(function (res) {
        _this.data = res.list ? res.list[0] : {};
      });
    }
  }
};